import styled from '@emotion/styled'
export const StyleCard = styled.div<any>`
  background: ${(props: any) => props.theme.colors[props.bg]};
  padding: 0px 20px;
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
`
export const StyleLeftCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 15px;
`
export const StyleRightCardWrapper = styled.div`
  img {
    height: 200px;
  }
`
